<template>
  <div class="main">
    <router-view/>
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'
import { mobileCallJsMethodNoResult } from './embedAppPage/utils/sendAppData'

export default {
  name: 'NewMainView',
  i18n,
  data () {
    const { params } = this.$route
    return {
      module: params.module
    }
  },
  mounted () {
  },
  created () {
    window.mobileCallJsMethodNoResult = mobileCallJsMethodNoResult
    console.log('main-window', window)
  },
  watch: {
    $route (to, from) {
      this.module = to.params.module
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.main {
  height: 100%;
  width: 100%;

  & .new-view-layout {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #F5F8FA;

    & .step-item {
      & .step-main {
        font-size: 12px;
        line-height: 22px;
        box-sizing: border-box;
        width: 100%;
        & span {
          margin-left: 8px;
          font-size: 12px;
        }
      }
      &.passed-node {
        & span {
          color: #4EC01E;
        }
      }

      &.review-node {
        & span {
          color: #FFA31A;
        }
      }

      &.wait-node {
        & span {
          color: #9BA0B4;
        }
      }

      &.reject-node {
        & span {
          color: #FF5E68;
        }
      }
    }

    & .review-user-wrap {
      overflow: auto;
      padding-right: 16px;
    }

    & .review-user {
      margin-top: 9px;
      padding-right: 9px;
      overflow: auto;
      display: flex;
      & .user-avatar {
        display: flex;
        flex-direction: column;
        margin-right: 8px;
        width: 40px;
        position: relative;
        & .status-icon {
          position: absolute;
          top: 25px;
          left: 26px;
        }
        & .avatar {
          width: 36px !important;
          height: 36px !important;
          line-height: 36px !important;
          font-size: 14px !important;
          margin-top: 3px;
        }
        & em {
          display: block;
          margin-top: 2px;
          line-height: 20px;
          color: var(--fontBasicColor);
          font-size: 10px;
          text-align: center;
        }
      }

      &.visitor-user {
        margin-top: 0;
        padding-right: 0;
        padding-top: 4px;
        & .user-avatar {
          width: 36px;
        }
      }
    }

  }

  & .collection-view,
  & .review-view,
  & .workflow-view {
    display: flex;
  }

  & .collection-detail {
    flex: 1 1 auto;
    overflow: auto;
    padding: 12px 20px;
    display: flex;
    flex-direction: column;
  }

  & .review-detail-main,
  & .workflow-view-main {
    flex: 1 1 auto;
    overflow: auto;
    padding: 12px 20px;
    display: flex;
    flex-direction: column;

  }

  & .workflow-form,
  & .review-form {
    padding: 8px 0;
    display: flex;
    & .review-action-button,
    & .submit-btn {
      display: flex;
      width: 100%;
      position: relative;

      & .btn-more {
        margin-right: 16px;
        width: 40px;
        height: 40px;
        box-sizing: border-box;
        border: 1px solid #D8E0E8;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        & i {
          font-size: 24px;
          color: #9BA7BA;
        }
      }

      & .btn-r {
        display: flex;
        flex: 1 1 auto;
        justify-content: space-between;
        & .disagree {
          margin-right: 16px;
          border: 1px solid #FF5E68;
          color: #FF5E68;
          background-color: #fff;
        }

        & .agree {
          border: 1px solid var(--btnPrimaryColor);
          background-color: var(--btnPrimaryColor);
          color: #fff;
        }

        & .disagree,
        & .agree {
            flex: 1;
            width: 100%;
            border-radius: 4px;
            font-weight: 600;
            font-size: 14px;
            text-align: center;
            line-height: 40px;
            box-sizing: border-box;
            height: 40px;
          }
        & .closed {
          width: 100%;
          border-radius: 4px;
          font-weight: 600;
          font-size: 14px;
          text-align: center;
          line-height: 40px;
          border: 1px solid var(--btnPrimaryColor);
          background-color: var(--btnPrimaryColor);
          color: #fff;
        }
      }

      & .popover {
        position: absolute;
        bottom: 56px;
        left: 0;
        background-color: #fff;
        box-shadow: 0px 11px 25px 4px rgba(27, 37, 50, 0.07), 0px 7px 17px -2px rgba(75, 85, 105, 0.12);
        border-radius: 8px;
        & ul {
          padding: 8px 0;
          width: 100px;
          & li {
            height: 32px;
            padding: 0 12px;
            line-height: 32px;
            color: #1B2532;
            font-size: 14px;
          }
        }
      }

    }

    & .submit-btn {
      height: 40px;
      background: var(--btnPrimaryColor);
      border-radius: 4px;
      line-height: 40px;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      display: block;
    }
  }

  & .review-detail,
  & .workflow-detail {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

}
</style>
